import {
  EyeStroke,
  FloppyDisk1Stroke,
  Pencil1Stroke,
  PlusStroke,
  PrinterStroke,
  RefreshCircle1ClockwiseStroke
} from '@lineiconshq/free-icons';
import { Lineicons } from '@lineiconshq/react-lineicons';
import { ActionBarV2, ActionButtonV2, AritoIcon, MenuButtonV2 } from '@/components/custom/erp';

interface ActionBarProps {
  onSearch?: () => void;
  onRefresh?: () => void;
  onFixedColumns?: () => void;
  onExportData?: () => void;
  onAddButtonCLick?: () => void;
  className?: string;
}

export const ActionBar: React.FC<ActionBarProps> = ({
  onSearch,
  onRefresh,
  onFixedColumns,
  onExportData,
  onAddButtonCLick,
  className
}) => {
  return (
    <ActionBarV2
      className={className}
      titleComponent={
        <div>
          <h1 className='text-xl font-bold'>Hóa đơn điều chỉnh thông tin</h1>
          <span className='flex items-center justify-center text-xs font-semibold text-gray-500'>
            <div className='mr-2 size-2 rounded-full bg-red-500' />
            Điều chỉnh [Hóa đơn bán hàng/Xác thực] từ ngày 01/04/2025 đến ngày 05/04/2025
          </span>
        </div>
      }
    >
      {onAddButtonCLick && <ActionButtonV2 icon={PlusStroke} title='Thêm mới HĐ' onClick={onAddButtonCLick} />}

      {onRefresh && <ActionButtonV2 icon={Pencil1Stroke} title='Chỉnh sửa HĐ' onClick={onRefresh} />}
      {onFixedColumns && (
        <MenuButtonV2
          title='In ấn'
          icon={<Lineicons aria-hidden='true' icon={PrinterStroke} size={18} />}
          items={[
            { title: 'Xem mẫu in nháp(Viettel)', icon: <AritoIcon icon={16} />, onClick: () => {} },
            { title: 'Mẫu in hóa đơn điện tử', icon: <AritoIcon icon={16} />, onClick: () => {} }
          ]}
        />
      )}
      {onExportData && (
        <ActionButtonV2 icon={EyeStroke} title='Xem các điều chỉnh của hóa đơn' onClick={onExportData} />
      )}
      {onExportData && <ActionButtonV2 icon={FloppyDisk1Stroke} title='Xác thực' onClick={onExportData} />}
      <MenuButtonV2
        items={[
          {
            title: 'Refresh',
            icon: <Lineicons aria-hidden='true' icon={RefreshCircle1ClockwiseStroke} className='h-4 w-4' />,
            onClick: () => {},
            group: 0
          },
          {
            title: 'Cố định cột',
            icon: <AritoIcon icon={16} />,
            onClick: () => {},
            group: 0
          },
          {
            title: 'Tìm kiếm',
            icon: <AritoIcon icon={584} />,
            onClick: onSearch,
            group: 0
          },

          {
            title: 'Kết xuất dữ liệu',
            icon: <AritoIcon icon={555} />,
            onClick: () => {},
            group: 1
          },
          {
            title: 'Xóa điều chỉnh',
            icon: <AritoIcon icon={8} />,
            onClick: () => {},
            group: 1
          }
        ]}
      />
    </ActionBarV2>
  );
};

export default ActionBar;
